import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CButton from "../components/button";
import { approvePrivacyPolicy } from "../controllers/auth";
import { getPrivacyPolicy } from "../controllers/privacy_policy";

const privacyPolicyLocales = {
  en: "en_US.json",
  sv: "sv_SE.json",
};

function SPrivacyPolicy() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const AskApproval = searchParams.get("ask_approval");

  const shouldAskApproval = useMemo(() => {
    return AskApproval == "true";
  }, [AskApproval]);

  const isLoading = useSelector((state) => state.privacyPolicy.isLoading);
  const privacyPolicy = useSelector(
    (state) => state.privacyPolicy.privacyPolicy
  );
  const locale = useSelector((state) => state.locale.locale);

  useEffect(() => {
    _init();
  }, []);

  const _init = () => {
    dispatch(
      getPrivacyPolicy({
        locale: privacyPolicyLocales[locale],
      })
    );
  };

  return (
    <div className="flex flex-col items-center justify-center sm:h-[100dvh] h-[90dvh] w-[100dvw]">
      <div className="flex flex-col md:h-[75dvh] md:w-[45dvw] h-[100dvh] w-[100dvw] sm:h-[80dvh] sm:w-[60dvw] bg-container-background p-[2%] overflow-x-scroll sm:rounded-[10px] rounded-none">
        <p className="text-[18px] font-[700] self-center">
          {t("privacy_policy_2")}
        </p>
        {privacyPolicy ? (
          <div className="flex flex-col justify-start h-[100%] w-[100%]">
            <div className="h-[2%]" />
            <p className="text-[18px] font-[600]">Privacy Policy for Qarlie</p>
            <p className="text-[16px] font-[600] italic">
              Last Updated: {privacyPolicy.updated_at}
            </p>
            <div className="h-[2%]" />
            <div
              className="prose"
              dangerouslySetInnerHTML={{
                __html: privacyPolicy.text,
              }}
            />
          </div>
        ) : null}
      </div>
      {shouldAskApproval ? (
        <CButton
          text={t("approve")}
          onClick={() => {
            dispatch(approvePrivacyPolicy());
          }}
        />
      ) : null}
    </div>
  );
}

export default SPrivacyPolicy;
